export default __webpack_public_path__ + "dd50850a9df503b551f83215f7629fee.png";